import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const projects = [
   {
    title: "DermETAS-SNA LLM",
    description:
      "Developed a skin cancer classification system using enhanced transformer architecture search, integrating transformer-based models with large language models and a medical corpus. Employed retrieval-augmented generation to improve diagnostic accuracy.",
    image: "/propop.png",
    github: "https://huggingface.co/spaces/SkinCancerDiagnosis/SkinCancerDiagnosis",
    live: "",
    tech: ["Python", "Large Language Models", "Transformer Models", "Retrieval Augmented Generation"],
  },
  {
    title: "DeepColon",
    description:
      "Deep learning application for colon cancer histopathological image classification using DenseNet and Autoencoder. Assists pathologists in identifying adenocarcinoma vs benign tissue.",
    image: "/DeepColon.png",
    github: "https://github.com/keerthi042000/DeepColon",
    live: "https://deepcolon.streamlit.app/",
    tech: ["Python", "TensorFlow", "Streamlit", "Keras"],
  },
  {
    title: "GiftWise",
    description:
      "Comprehensive gift card management web application with customer-facing and admin functionalities. Features secure authentication, order management, email notifications, and backend integration with Oracle Cloud Database. Built using Node.js, HTML/CSS, and JavaScript.",
    image: "/GiftWise.png",
    github: "https://github.com/keerthi042000/GiftWise",
    live: "https://giftwise-flame.vercel.app/",
    tech: ["HTML/CSS", "Javascript", "NodeJS", "Oracle SQL"],
  },
  {
    title: "SympTriage",
    description:
      "AI-powered web chatbot for disease diagnosis based on user-provided symptoms. Implements four machine learning models (Random Forest, k-NN, XGBoost, and MLP) with majority voting for robust predictions. Uses OpenAI to map user symptoms to a structured symptoms dataset before model inference, ensuring accurate diagnosis. Built with Next.js, Python, FastAPI, and Firebase for real-time data handling.",
    image: "/SympTriage.png",
    github: "https://github.com/keerthi042000/Symptriage",
    live: "https://symptriage-one.vercel.app/",
    tech: ["NextJS", "ML Models", "Python", "FastAPI", "Firebase", "OpenAI"],
  },
];

const Projects = () => {
  return (
    <div>
      <Navbar />
      <div className="text-white max-w-[1200px] mt-[-96px] mb-[20px] w-full h-full mx-auto px-4 font-main">
        <div className="pt-[150px] text-center">
          {/* <h1 className="text-[#2563eb] uppercase text-4xl font-bold">
            Projects
          </h1> */}
          <h1 className="text-[#00df9a] uppercase text-3xl">Projects</h1>
          {/* <p className="mt-4 text-gray-300">
            A collection of my key projects showcasing skills in software
            development, machine learning, and data science.
          </p> */}
        </div>

        {/* Projects Grid */}
        {/* <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12"> */}
        <div className="grid sm:grid-cols-1 gap-8 mt-12">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-[#111827] rounded-xl shadow-lg hover:shadow-2xl hover:scale-105 transition duration-300"
            >
              {/* <img
                src={project.image}
                alt={project.title}
                className="rounded-t-xl w-full h-48 object-cover"
              /> */}

              {/* <div className="flex justify-center">
                <img 
                    src={project.image} 
                    alt={project.title} 
                    // className="w-[90%] h-48 object-contain rounded-md shadow-md" 
                    className="w-[90%] h-48 object-contain rounded-md shadow-md mx-auto" 
                />
                </div> */}

                <div className="p-4">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-48 object-contain rounded-md mx-auto"
                  />
                </div>

                

              <div className="p-3">
                <h2 className="text-2xl font-semibold text-[#00df9a]">
                  {project.title}
                </h2>
                <p className="mt-2 text-gray-300">{project.description}</p>

                {/* Tech Stack */}
                <div className="mt-3 flex flex-wrap gap-2">
                  {project.tech.map((t, i) => (
                    <span
                      key={i}
                      className="bg-[#1f2937] text-gray-200 px-3 py-1 text-sm rounded-full"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                {/* Buttons */}
                <div className="mt-4 flex space-x-4">
                  {project.github && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-[#2563eb] text-white px-4 py-2 rounded-lg hover:bg-[#1d4ed8] transition"
                    >
                      GitHub
                    </a>
                  )}
                  {project.live && (
                    <a
                      href={project.live}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-[#00df9a] text-black px-4 py-2 rounded-lg hover:bg-[#06c184] transition"
                    >
                      Live Demo
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-[40px] mb-[30px]">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Projects;
